exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "np-mainstructures-outype .subtitle-label{color:#666;font-style:italic;font-size:.95em;margin-bottom:15px;font-weight:400}np-mainstructures-outype label.control-label{display:inline}", ""]);

// exports
